<div class="container-terms" [ngStyle]="{'grid-template-rows': showHeaderFooter ? '100px auto' : 'auto'}"
  [ngClass]="{'rapidScore': contratacion}" >
  <app-header *ngIf="showHeaderFooter" class="header">
  </app-header>
  <div class="container-center" [ngClass]="{'rapidScore': contratacion}"
    [ngStyle]="{'background-color': showHeaderFooter && !contratacion ? '#F9FCFF' : '#ffffff'}" role = "main">
    <div class="scroll-container">
      <div class="step-container">
        <div class="step">
          <div class="number one">1</div>
          <h1 class="one">{{ 'TERMS.CONDITIONS.CHECK_TERMS_1' | translate }}</h1>
        </div>
        <div class="step">
          <div class="number two">2</div>
          <h1 class="two">{{ 'TERMS.CONDITIONS.CHECK_POLITY' | translate }}</h1>
        </div>
      </div>

      <div class="text-container" *ngIf="this.country == 'ES'">
        <h2 class="title-p">{{ 'TERMS.CONDITIONS.CHECK_TERMS_1' | translate }}</h2>

        <div class="container" *ngIf="!contratacion && !signin">

          <span [innerHTML]="'TERMS.TERMSFILE.PART1TEXT' | translate | safeHtml"></span>


          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART2TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART3' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART3TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART4' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART4TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART5TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART7TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART8TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART9TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART10TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>

            </li>
          </ol>
        </div>
        <div class="container" *ngIf="!contratacion && signin">

          <span [innerHTML]="'TERMS.TERMSFILE.PART16TEXT' | translate | safeHtml"></span>


          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART2TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART3' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART3TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART16' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART17TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART18TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART19TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART20TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART21TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART22TEXT' | translate | safeHtml"></span>



            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>
            </li>
          </ol>
        </div>
        <div class="container" *ngIf="contratacion && tyc == 2">

          <span [innerHTML]="'TERMS.TERMSFILE.PART23TEXT' | translate | safeHtml"></span>

          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART24TEXT' | translate | safeHtml"></span>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART17' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART25TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART4' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART26TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART27TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART28TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART29TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART30TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART31TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>
            </li>
          </ol>
        </div>
        <div class="container" *ngIf="contratacion && tyc == 1">

          <span [innerHTML]="'TERMS.TERMSFILE.PART32TEXT' | translate | safeHtml"></span>

          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART33TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART4' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART34TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART35TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART28TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART29TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART36TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART31TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>
            </li>
          </ol>
        </div>
      </div>

      <div class="text-container" *ngIf="this.country == 'PT'">
        <h2 class="title-p">{{ 'TERMSPT.CONDITIONS.CHECK_TERMS_1' | translate }}</h2>

        <div class="container" *ngIf="!contratacion && !signin">

          <span [innerHTML]="'TERMSPT.TERMSFILE.PART1TEXT' | translate | safeHtml"></span>


          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART2TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART3' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART3TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART4' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART4TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART5TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART7TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART8TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART9TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART10TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>

            </li>
          </ol>
        </div>
        <div class="container" *ngIf="!contratacion && signin">

          <span [innerHTML]="'TERMS.TERMSFILE.PART16TEXT' | translate | safeHtml"></span>


          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART2TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART3' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART3TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART16' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART17TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART18TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART19TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART20TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART21TEXT' | translate | safeHtml"></span>


            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART22TEXT' | translate | safeHtml"></span>



            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>
            </li>
          </ol>
        </div>
        <div class="container" *ngIf="contratacion && tyc == 2">

          <span [innerHTML]="'TERMS.TERMSFILE.PART23TEXT' | translate | safeHtml"></span>

          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART24TEXT' | translate | safeHtml"></span>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART17' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART25TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART4' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART26TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART27TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART28TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART29TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART30TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART31TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>
            </li>
          </ol>
        </div>
        <div class="container" *ngIf="contratacion && tyc == 1">

          <span [innerHTML]="'TERMS.TERMSFILE.PART32TEXT' | translate | safeHtml"></span>

          <ol>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART2' | translate }}</h3>

              <span [innerHTML]="'TERMS.TERMSFILE.PART33TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART4' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART34TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART5' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART35TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART6' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART6TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART7' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART28TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART8' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART29TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART9' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART36TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART10' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART31TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART11' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART11TEXT' | translate | safeHtml"></span>
            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART12' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART12TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART13' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART13TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART14' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART14TEXT' | translate | safeHtml"></span>

            </li>
            <li>
              <h3>{{ 'TERMS.TERMSFILE.TITLEPART15' | translate }}</h3>
              <span [innerHTML]="'TERMS.TERMSFILE.PART15TEXT' | translate | safeHtml"></span>
            </li>
          </ol>
        </div>
      </div>

      <div *ngIf="showButton && !justShow" class="button">
        <button type="submit" class="cancel" (click)="backView()">{{ 'TERMS.BUTTONS.CANCEL' | translate }}</button>
        <button type="submit" class="accept" (click)="agreeTerms()" aria-label="Aceptar">{{ 'TERMS.BUTTONS.ACCEPT' | translate }}</button>
      </div>
    </div>
  </div>
  <app-footer *ngIf="showHeaderFooter && !contratacion" class="footer" [colorItems]="'#ffffff'" [classSpecial]="true" role = "contentinfo">
  </app-footer>
</div>
